module.exports = __webpack_public_path__ + "img/img9.bac506a8.svg";